export default "__VITE_ASSET__8ffb3488__"